import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

/**
 * Admin /stats fetcher. Redirects to /dashboard on 403.
 * Auto-fetches when `enabled` becomes true.
 */
export function useAdminStats({ token, enabled, onForbidden }) {
  const [stats, setStats] = useState(null);

  const fetchStats = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/admin/stats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
      if (error.response?.status === 403) {
        toast.error('Admin access required');
        onForbidden?.();
      }
    }
  }, [token, onForbidden]);

  useEffect(() => {
    if (enabled) fetchStats();
  }, [enabled, fetchStats]);

  return { stats, refetchStats: fetchStats };
}
